export enum VacancyState {
  open = 'OPEN',
  hold = 'HOLD',
  closed = 'CLOSED'
}
